import { render, staticRenderFns } from "./priceHistory.vue?vue&type=template&id=adab2bc0&scoped=true"
import script from "./priceHistory.vue?vue&type=script&lang=js"
export * from "./priceHistory.vue?vue&type=script&lang=js"
import style0 from "./priceHistory.vue?vue&type=style&index=0&id=adab2bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adab2bc0",
  null
  
)

export default component.exports